var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 21.9996C9.8284 21.9996 10.5 21.3281 10.5 20.4996C10.5 19.6712 9.8284 18.9996 8.99998 18.9996C8.17155 18.9996 7.49998 19.6712 7.49998 20.4996C7.49998 21.3281 8.17155 21.9996 8.99998 21.9996Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.9996C17.3284 21.9996 18 21.3281 18 20.4996C18 19.6712 17.3284 18.9996 16.5 18.9996C15.6715 18.9996 15 19.6712 15 20.4996C15 21.3281 15.6715 21.9996 16.5 21.9996Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599976 2.99961C0.599976 2.50255 1.00292 2.09961 1.49998 2.09961H4.13629C4.56695 2.09961 4.93725 2.40469 5.01966 2.82739L5.78754 6.76616H21.105C21.3725 6.76616 21.6261 6.88514 21.7971 7.09083C21.9681 7.29651 22.0387 7.5676 21.9898 7.83058L20.5336 15.6676C20.4525 16.0871 20.1857 16.4985 20.0373 16.7137C19.9485 16.8426 19.8638 16.9541 19.8016 17.0333C19.7702 17.0732 19.7439 17.1057 19.7248 17.129L19.7174 17.138C19.7125 17.1445 19.7073 17.1512 19.702 17.1581C19.672 17.1965 19.6346 17.2399 19.5887 17.2861C19.4964 17.3789 19.3718 17.4806 19.2084 17.5742C18.8764 17.7643 18.4225 17.8993 17.82 17.8993H8.39876C7.75777 17.9095 7.13651 17.689 6.64254 17.2808C6.14681 16.8711 5.81146 16.2994 5.68919 15.6684L4.17025 7.87716C4.16426 7.85224 4.15932 7.82692 4.15545 7.80124L3.39481 3.89961H1.49998C1.00292 3.89961 0.599976 3.49667 0.599976 2.99961Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutActive);
export default __webpack_public_path__ + "static/media/checkout-active.45c95bec23476277f4afef9954f50da3.svg";
export { ForwardRef as ReactComponent };